import { Link } from "@tanstack/react-router";
import { m } from "@/paraglide/messages";
import { CATEGORY_LIST } from "../lib/units";

/** Grid of links to every converter category. */
export function UcCategories({ currentId }: { currentId?: string }) {
  return (
    <section className="mt-12">
      <h2 className="mb-4 font-display text-xl font-bold tracking-tight">
        {m.uc_categories_title()}
      </h2>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {CATEGORY_LIST.map((c) => {
          const active = c.id === currentId;
          return (
            <Link
              key={c.id}
              to="/unit-converter/$category"
              params={{ category: c.id }}
              aria-current={active ? "page" : undefined}
              className={`flex items-center gap-2.5 rounded-xl border px-4 py-3 text-sm font-medium transition-colors ${
                active
                  ? "border-primary/60 bg-primary/10 text-primary"
                  : "border-border bg-card/40 hover:border-primary/50 hover:bg-primary/10"
              }`}
            >
              <span aria-hidden>{c.icon}</span>
              <span>{c.name()}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
